import React from 'react';
import cx from 'classnames';
import Modal from '@mui/material/Modal';
import Backdrop from '@mui/material/Backdrop';
import Zoom from '@mui/material/Zoom';
import CloseIcon from '@mui/icons-material/Close';
import styled, { css } from 'styled-components';
import { ModalStyles } from 'theme/commonStyles';
import { GradientShadowBox } from 'components/styled/Box';
import { TYPE } from 'theme';

const ModalWrapper = styled(Modal)`
    display: flex;
    align-items: center;
    justify-content: center;

    .MuiBackdrop-root {
        backdrop-filter: blur(20px);
    }
`;

const shadowStyle = css`
    box-shadow: 0px 0px 80px 0px ${({ theme }) => `${theme.c.primary02}`};
`;

const ContentWrapper = styled(GradientShadowBox).attrs((props) => ({
    // top: 20,
    // right: -100,
    // left: -100,
    // bottom: -50,
    background: props.theme.c.radialGradientBg,
}))<{ shadowType: string }>`
    position: relative;
    border-radius: 24px;
    ${({ shadowType }) => shadowType === 'box' ? shadowStyle : undefined}
`;


const Content = styled.div`
    ${ModalStyles}
    position: relative;
    min-width: 380px;
    max-width: 800px;
    padding: 30px 28px;
    outline: none;
    box-sizing: border-box;
    background-color: #000;
    color: #fff;

    /* background: #e9ebf4; */
    border-radius: 24px;
    max-height: 96vh;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        width: 0;
    }
    ${({ theme }) => theme.mediaWidth.upToSmall`
        width: calc(100vw - 2rem);
        min-width:80vw;
        max-width: calc(100vw - 2rem);
        padding: 1rem;
    `}
`;
const CloseIconWrapper = styled.div`
    position: absolute;
    right: 20px;
    top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    z-index: 1;
    border-radius: 12px;
    cursor: pointer;

    ${({ theme }) => theme.mediaWidth.upToSmall`
        right: 1rem;
        top: 1rem;
    `}
`;

export interface ModalProps {
    id?: string;
    isOpen?: boolean;
    onClose?(): void;
    children?: React.ReactNode;
    customContentClass?: string;
    hideClose?: boolean;
    disableBackgroundClick?: boolean;
    keepMounted?: boolean;
    className?: string;
    backgroundColor?: string;
    iconStyle?: React.CSSProperties;
    iconWrapperStyle?: React.CSSProperties;
    contentStyle?: React.CSSProperties;
    closeIcon?: React.ReactNode;
    shadowProps?: any | boolean;
    title?: React.ReactNode;
}

const StyledCloseIcon = styled(CloseIcon)`
    width: 24px;
    height: 24px;
    color: #fff;
    &:hover {
        opacity: 0.8;
    }
`;

export default function TransitionsModal({
    id,
    isOpen,
    onClose,
    children,
    customContentClass,
    hideClose,
    keepMounted,
    disableBackgroundClick = false,
    className,
    backgroundColor,
    iconStyle = {},
    iconWrapperStyle = {},
    closeIcon,
    contentStyle = {},
    shadowProps = {},
    title,
}: ModalProps) {
    const shadow =
        shadowProps === true
            ? {
                  top: 20,
                  right: -100,
                  left: -100,
                  bottom: -50,
              }
            : shadowProps;
    return (
        <ModalWrapper
            id={id}
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={cx(className)}
            open={!!isOpen}
            onClose={onClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            keepMounted={keepMounted}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Zoom in={isOpen}>
                <ContentWrapper {...shadow}>
                    <Content className={cx('modalContent', customContentClass)} style={{ ...contentStyle }}>
                        {!hideClose && (
                            <CloseIconWrapper className="closeIcon" style={{ ...iconWrapperStyle }} onClick={onClose}>
                                {closeIcon ? closeIcon : <StyledCloseIcon style={{ ...iconStyle }} />}
                            </CloseIconWrapper>
                        )}
                        {title ? (
                            <TYPE.main fontWeight={600} marginBottom="20px">
                                {title}
                            </TYPE.main>
                        ): null}
                        {children}
                    </Content>
                </ContentWrapper>
            </Zoom>
        </ModalWrapper>
    );
}
